import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { DESTINATIONS, INDIA } from "../lib/data";

// Simplified continents as soft blobs (decorative dark-green landmasses)
const LAND =
  "M120 150 Q180 110 260 130 Q320 145 300 200 Q260 250 200 240 Q140 230 120 150Z " +
  "M330 150 Q420 120 520 150 Q560 200 500 250 Q420 300 360 260 Q320 210 330 150Z " +
  "M480 270 Q540 250 580 320 Q560 420 500 430 Q450 380 470 320 Q470 290 480 270Z " +
  "M560 190 Q640 170 700 210 Q740 280 660 300 Q600 300 580 250 Q560 220 560 190Z " +
  "M720 330 Q800 310 850 360 Q860 410 800 420 Q740 400 720 360Z";

export default function WorldMap() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <div ref={ref} className="relative w-full" data-testid="world-map">
      <svg viewBox="0 0 900 480" className="w-full h-auto">
        <path d={LAND} fill="#F5F2E9" opacity="0.06" stroke="#F5F2E9" strokeOpacity="0.12" strokeWidth="1" />

        {DESTINATIONS.map((d, i) => {
          const mx = (INDIA.x + d.x) / 2;
          const my = Math.min(INDIA.y, d.y) - 60;
          const path = `M${INDIA.x} ${INDIA.y} Q ${mx} ${my} ${d.x} ${d.y}`;
          return (
            <g key={d.name}>
              <motion.path
                d={path} fill="none" stroke="#C5A059" strokeWidth="1.2" strokeLinecap="round"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={inView ? { pathLength: 1, opacity: 0.85 } : {}}
                transition={{ duration: 1.6, delay: 0.3 + i * 0.15, ease: "easeInOut" }}
              />
              <motion.circle
                cx={d.x} cy={d.y} r="3.5" fill="#C5A059"
                initial={{ scale: 0 }} animate={inView ? { scale: 1 } : {}}
                transition={{ delay: 0.6 + i * 0.15, type: "spring" }}
              />
              <motion.circle
                cx={d.x} cy={d.y} r="3.5" fill="none" stroke="#C5A059"
                initial={{ scale: 1, opacity: 0.8 }}
                animate={inView ? { scale: [1, 3], opacity: [0.8, 0] } : {}}
                transition={{ duration: 2, delay: 0.8 + i * 0.15, repeat: Infinity, repeatDelay: 1 }}
              />
              <text x={d.x + 8} y={d.y + 3} fill="#F5F2E9" fillOpacity="0.7" fontSize="11" className="font-sans">
                {d.name}
              </text>
            </g>
          );
        })}

        {/* India origin */}
        <motion.circle cx={INDIA.x} cy={INDIA.y} r="6" fill="#C5A059"
          initial={{ scale: 0 }} animate={inView ? { scale: 1 } : {}} transition={{ type: "spring" }} />
        <text x={INDIA.x + 10} y={INDIA.y - 8} fill="#C5A059" fontSize="13" className="font-serif italic">India</text>
      </svg>
    </div>
  );
}
